export default __webpack_public_path__ + "media/images/mailer-new/welcome-icons/edit_profile_step-off-8604a4196dcd75abd71006ef5b644a1d.png";